module.exports = __webpack_public_path__ + "static/media/policy-3.9e5b0281.png";